import { jsx } from "react/jsx-runtime";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { validateTidalLicense } from "../../base/index.js";
function PhoneIphone(props) {
  return /* @__PURE__ */ jsx(
    PhoneIphoneIcon,
    {
      "data-testid": "PhoneIphone",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PhoneIphone",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
PhoneIphone.tidalIconMeta = {
  categories: "devices,photos",
  name: "PhoneIphone"
};
validateTidalLicense();
export {
  PhoneIphone
};
//# sourceMappingURL=PhoneIphone.js.map
